import Swiper, { Navigation } from "swiper";

const popularBrandsSwiper = new Swiper(".popular-brands__slider", {
    width: 241,
    freeMode: true,
    spaceBetween: 10,
    loop: true,
    grabCursor: true,
});

const howToBuySwiper = new Swiper(".how__slider", {
    navigation: {
        nextEl: ".how__slider-button--next",
        prevEl: ".how__slider-button--prev",
    },
    modules: [Navigation],
});

const similarProposals = new Swiper(".proposals__slider", {
    slidesPerView: 1,
    spaceBetween: 16,
    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        870: {
            slidesPerView: 3,
        },
    },
    grabCursor: true,
});
